import { searchParamsStorage } from "@analytics/parseSearchParams/searchParamsStorage";

export const cleanSearchParamsStorageByKeys = async (keys: string[]) => {
  for (const key of keys) {
    await searchParamsStorage.removeItem(key);
  }
};
